import { render, staticRenderFns } from "./BFlowTypedParamEditor.vue?vue&type=template&id=148b431e&"
import script from "./BFlowTypedParamEditor.vue?vue&type=script&lang=js&"
export * from "./BFlowTypedParamEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports